import { render, staticRenderFns } from "./header-guest.vue?vue&type=template&id=05d7e838&scoped=true"
import script from "./header-guest.vue?vue&type=script&lang=js"
export * from "./header-guest.vue?vue&type=script&lang=js"
import style0 from "./header-guest.vue?vue&type=style&index=0&id=05d7e838&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d7e838",
  null
  
)

export default component.exports